var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 12.3334V15.6667H33.6666V12.3334H26.9999ZM23.6666 23.35C25.2666 24.5334 27.3499 26.1 28.9999 27.3334C29.6666 26.45 30.3333 25.55 30.9999 24.6667C29.3499 23.4334 27.2666 21.8667 25.6666 20.6667C24.9999 21.5667 24.3333 22.4667 23.6666 23.35ZM30.9999 3.33335C30.3333 2.45002 29.6666 1.55002 28.9999 0.666687C27.3499 1.90002 25.2666 3.46669 23.6666 4.66669C24.3333 5.55002 24.9999 6.45002 25.6666 7.33335C27.2666 6.13335 29.3499 4.58335 30.9999 3.33335ZM3.66659 9.00002C1.83325 9.00002 0.333252 10.5 0.333252 12.3334V15.6667C0.333252 17.5 1.83325 19 3.66659 19H5.33325V25.6667H8.66659V19H10.3333L18.6666 24V4.00002L10.3333 9.00002H3.66659ZM22.8333 14C22.8333 11.7834 21.8666 9.78335 20.3333 8.41669V19.5667C21.8666 18.2167 22.8333 16.2167 22.8333 14Z",
    fill: "#D52222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.df31c88c8d66fd892ae82d0db0671064.svg";
export { ForwardRef as ReactComponent };